export default "__VITE_ASSET__DgLh8dfz__"